import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';

class SetupApplicationUserInstruction extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.close = this.close.bind(this);
    this.continue = this.continue.bind(this);
  }

  close() {
    this.props.onClose();
  }

  continue() {
    this.props.onClose();
    this.props.continue();
  }

  render() {
    const { show, name, instanceUrl, tenantId } = this.props;
    return (
      <Modal bsSize="md" show={show} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Required Setup Application User{name !== null ? (<span> for <strong>{name}</strong></span>) : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
              Please follow the instructions below to setup an Application User for TruSales.
            </p>
            <p>
              <a target="_blank" rel="noreferrer" href="https://docs.microsoft.com/en-us/power-platform/admin/manage-application-users#create-an-application-user">
                https://docs.microsoft.com/en-us/power-platform/admin/manage-application-users#create-an-application-user <Fa name="external-link" />
              </a>
            </p>

            <p />
            <hr />
            <p />
            
            <ul>
              {instanceUrl !== null && <li><small>Your CRM instance: <a target="_blank" rel="noreferrer" href={`${instanceUrl}`}>{instanceUrl} <Fa name="external-link" /></a></small></li>}
              {tenantId !== null && <li><small>Your Tenant Id: <code>{tenantId}</code></small></li>}
              {process.env.REACT_APP_MD_CLIENT_ID && <li><small>TruSales Application ID: <code>{process.env.REACT_APP_MD_CLIENT_ID}</code></small></li>}
            </ul>


          </div>
        </Modal.Body>
        <Modal.Footer className="clearfix">
          <Button bsStyle="default" className="pull-left" onClick={this.close}>Cancel</Button>
          <Button bsStyle="primary" className="pull-right" onClick={this.continue}>I have finished setting up the Application User</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SetupApplicationUserInstruction.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  name: PropTypes.string,
  instanceUrl: PropTypes.string,
  tenantId: PropTypes.string,
  continue: PropTypes.func,
};
SetupApplicationUserInstruction.defaultProps = {
  onClose: () => {},
  continue: () => {},
  show: false,
  tenantId: null,
  instanceUrl: null,
  name: null,
};

export default SetupApplicationUserInstruction;
